import axios from 'axios';
import download from 'downloadjs';


/**
 * @typedef {object} Group
 * @property {number} id
 * @property {string} label
 * @property {object} groupTerm
 * @property {string} groupTerm.id
 * Potentially more...
 */

export default {
    getAll(context, roles, excludeRole) {

        var options = {
            url: window.apiUrl + '/users?roles=' + roles + '&exclude_role=' + excludeRole,
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;
        });

    },
    getDocuments() {

        var options = {
            url: window.apiUrl + '/documents',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;
        });

    },
    getDocument(doc) {

        var options = {
            url: window.apiUrl + '/document?name=' + doc.name + '&type=' + doc.type,
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET',
            responseType: 'blob'

        };

        return axios.request(options).then(function(response) {
                download(response.data, doc.name);
                return true;
        });

    },
    /**
     * @async
     * @param {number} userId
     * @returns {object}   user
     * @returns {number}   user.id
     * @returns {string}   [user.firstName]
     * @returns {string}   [user.lastName]
     * @returns {string}   [user.avatar]
     * @returns {number[]} [user.group]
     */
    getUser(userId) {
        const options = {
            method: 'GET',
            baseURL: window.apiUrl,
            url: '/users',
            headers: {
                'Authorization': 'Bearer ' + localStorage.token
            }
        };
        return axios.request(options).then(response => {
            //if (!response.data.success) {
            //  throw new Error(response.data.error);
            //}
            if (!Array.isArray(response.data)) {
                throw new Error('request to get user failed');
            }
            const user = response.data.find(u => u.id == userId);
            if (!user) {
                throw new Error('user not found');
            }
            return user;
        });
    },

    acceptPrivacy(context) {

        var options = {
            url: window.apiUrl + '/privacy-policy',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'POST'
        };

        return axios.request(options).then(function(response) {
            return response;
        });

    },

    getMe(context, id) {

        let url = window.apiUrl + '/me';
        if (id) url = url + '?userId=' + id;

        var options = {
            url: url,
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },

    getMarks(context, id) {
        let url = window.apiUrl + '/marks';
        if (id) url = url + '?userId=' + id;

        var options = {
            url: url,
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },
    changePassword(data) {
        var options = {
            url: window.apiUrl + '/password',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'PATCH',
            data: data
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getSettings(context) {
        var options = {
            url: window.apiUrl + '/settings',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },
    selfUpdate(context, data) {
        var options = {
            url: window.apiUrl + '/users',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: data,
            method: 'PATCH'
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },
    updateStatus(context, data, userId) {
        let url = window.apiUrl + '/status';
        if (userId) url = url + '?userId=' + userId;
        var options = {
            url: url,
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: data,
            method: 'POST'
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },

    updateSettings(context, data) {
        var options = {
            url: window.apiUrl + '/settings',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: data,
            method: 'POST'
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getTranscript(context, userId) {
        let url = window.apiUrl + '/transcript';
        if (localStorage.roles.includes('OnlineDirector')) {
            url += '?user_id=' + userId;
        }
        var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET',
            responseType: 'blob'
        }

        return axios.request(options).then(function(response) {
                const transcriptName = 'Think_Tank_Online_Transcript_' + localStorage.user_name.replace(/ /g, '_') + '.pdf';
                download(response.data, transcriptName);
                return true;
        }).catch(function(error) {
            console.log(error);
            return(error);
        });
    },
    setAvatar(context, url) {

        var data = {
            url: url
        };

        var options = {
            url: window.apiUrl + '/avatar',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: data,
            method: 'POST'
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getGroups(context, termId) {
        let url = window.apiUrl + '/groups';
        if (termId) {
            url += '/' + termId
        }
        var options = {
            url: url,
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET',
        }

        return axios.request(options).then(function(response) {
            return response;

        }).catch(function(error) {
            console.log(error)
            return (error);
        });
    },

    /**
     * Performs the same as getGroups(), but handles extracting the data from
     * the http response.
     * @param {string} [termId]
     * @returns {Group[]}
     * TODO: should be renamed to searchGroups() or getGroupsByTerm(), since
     * this also does filtering
     */
    getGroups_clean(termId) {
        const options = {
            method: 'GET',
            baseURL: window.apiUrl,
            url: '/all-groups',
            headers: {
                'Authorization': 'Bearer ' + localStorage.token
            }
        };
        return axios.request(options).then(response => {
            // `/all-groups` doesn't return a success field
            //if (!response.data.success) {
            //  throw new Error(response.data.error);
            //}
            if (termId) {
                return response.data.groups.filter(g => g.groupTerm.id === termId);
            } else {
                return response.data.groups;
            }
        });
    },

    /**
     * @param {number} groupId
     * @returns {Group}
     */
    getGroup(groupId) {
        return module.exports.default.getGroups_clean().then(groups => {
            const group = groups.find(g => g.id == groupId);
            if (group) {
                return group;
            }
            throw new Error('group not found');
        });
    },

    setPath(context, path, type) {
        let data = {
            path: path,
            type: type,
            studentNumber: localStorage.account_id
        };

        data.term = localStorage.terms.split(',').pop();

        var options = {
            url: window.apiUrl + '/user/path',
            data: data,
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'POST',
        }

        return axios.request(options).then(function(response) {
            return response;

        }).catch(function(error) {
            console.log(error)
            return (error);
        });

    },
    /**
     * @async
     * @param {string} searchTerm
     * @param {boolean} [students] - only search for students
     * @returns {object[]} users
     * @returns {number}   users[].id
     * @returns {string}   [users[].firstName]
     * @returns {string}   [users[].lastName]
     * @returns {string}   [users[].avatar]
     * @returns {number}   [users[].group] - TODO: this may actually been an array?
     */
    searchUsers(searchTerm, students) {
        const options = {
            method: 'GET',
            baseURL: window.apiUrl,
            url: '/users/search',
            params: {
                search: searchTerm,
                students: !!students
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.token
            }
        };
        return axios.request(options).then(response => {
            if (!response.data.success) {
                throw new Error(response.data.error);
            }
            return response.data.users;
        });
    }


};



// WEBPACK FOOTER //
// ./src/services/users/index.js